<template>
  <div class="component-small-class" v-if="inital">
    <h1 class="h1 color-gray-1">
      幸福心理学 <br class="m-only" />
      <span class="color-gray-4">Positive Psychology</span>
    </h1>
    <VideoPlayer :videos="videos" :isPaid="isPaid">
      <Button v-if="isPaid" slot="download" class="download-btn" skin="grey" @click="$windowOpen(pdf)">下载课程脑图</Button>
    </VideoPlayer>
    <p class="text1 color-gray-2 mt-24">
      “收到哈佛Offer”，“周游世界”，“实现一个亿小目标”，哪件事会让你感到无比幸福？如果告诉你，这些事可能并不能使你感到幸福，你会怎么想？
    </p>
    <p class="text1 color-gray-2 mt-10">
      很难想象，简简单单的“happiness”会成为哈佛大学研究了将近80年的命题。而《幸福心理学》这门课在哈佛曾经连续N年蝉联全校最多人选、而且出席率奇高，几乎每一节都是千人爆满的状态。
    </p>
    <p class="text1 color-gray-2 mt-10">
      幸福的本质究竟是什么？不幸福的根本原因又包含什么？财富和成功，在多大程度上能带给人长久的幸福感？在全球环境快速变化的今天，我们怎样可以掌控自己的幸福？又有哪些获得幸福的“捷径”？
    </p>
    <p class="text1 color-gray-2 mt-10">
      就连哈佛学霸这样的“别人家孩子”都视作刚需的《幸福心理学》，那些考纲和心灵鸡汤不教你的心理学知识，来这堂哈佛在线课一起学习吧。
    </p>
  </div>
</template>
<script>
import Permission from 'utils/permission';
import { Codes } from 'api';
import Mixin from '../mixin.vue';
/**
 * @module Positive
 * @desc 幸福学课程内页
 */
export default {
  name: 'Positive',
  mixins: [Mixin],
  data() {
    return {
      // videos: [
      //   { url: 'https://hsylc.oss-cn-hangzhou.aliyuncs.com/2022/student_file/enroll/Positive_Psychology01.mp4', index: 1 },
      //   { url: 'https://hsylc.oss-cn-hangzhou.aliyuncs.com/2022/student_file/enroll/Positive_Psychology02.mp4', index: 2 }
      // ],
      pdf: 'https://hsylc.oss-cn-hangzhou.aliyuncs.com/2022/student_file/enroll/Positive_Psychology_MIndMap.pdf',
      inital: false
    };
  },
  computed: {
    videos() {
      if (this.isPaid) {
        return [
          { url: 'https://hsylc.oss-cn-hangzhou.aliyuncs.com/2022/student_file/enroll/Positive_Psychology01.mp4', index: 1 },
          { url: 'https://hsylc.oss-cn-hangzhou.aliyuncs.com/2022/student_file/enroll/Positive_Psychology02.mp4', index: 2 }
        ];
      } else {
        return [
          { url: 'https://hsylc.oss-cn-hangzhou.aliyuncs.com/2022/student_file/enroll/Positive_Psychology01.mp4', index: 1 }
          // { url: 'https://hsylc.oss-cn-hangzhou.aliyuncs.com/2022/student_file/enroll/Positive_Psychology02.mp4', index: 2 }
        ];
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.inital = true;
    }, 0);
  },
  methods: {
    pagePermission() {
      return new Promise((resolve, reject) => {
        Permission.hasApplyPaid().then(ret => {
          if (ret.status === Codes.SUCCESS) {
            const track = new this.$track();
            track.track({
              event: 'hsylc_student_small_class_positive_enter',
            });
            resolve(true);
          } else {
            reject(false);
          }
        }).solve();
      });
    }
  }
};
</script>
